import { Button, message } from "antd";
import { useState } from "react";
import K from "utilities/constants";
import Candidate from "../../../../../../redux/models/candidate";
import Client from "../../../../../../redux/models/client";
import { AddClassCandidateModal } from "./addClassCandidateModal";

export const AddClassCandidateButton = ({
  classId,
  disabled,
  onSuccess,
  getCandidateUdfs,
}) => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const onFinish = async (values) => {
    try {
      setLoading(true);
      const res = await Candidate.create(values, {
        showError: false,
        skipForbiddenRedirect: true,
      });

      if (values.cvFile) {
        try {
          await Client.createCvAttachment(
            res.id,
            values.cvFile,
          );
        } catch (err) {
          console.error(err);
          message.warning("Candidate created but CV upload failed.");
        }
      }

      setOpen(false);
      onSuccess?.(res);
    } catch (err) {
      console.error(err);
      if (err.statusCode === K.Network.StatusCode.Forbidden) {
        message.warning(err.message);
      } else {
        message.error(err.message ?? "Something went wrong");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button type="primary" onClick={() => setOpen(true)} disabled={disabled}>
        Create Candidate
      </Button>

      {open && (
        <AddClassCandidateModal
          title="Add New Candidate"
          open={open}
          loading={loading}
          onCancel={() => setOpen(false)}
          onFinish={onFinish}
          classId={classId}
          getCandidateUdfs={getCandidateUdfs}
        />
      )}
    </>
  );
};
